import React from "react";

interface ListicleCardProps {
  content: any;
}

const ListicleCard: React.FC<ListicleCardProps> = ({ content }) => {
  const blocks: any[] = content?.latest_version?.blocks || [];
  const listItemCount = blocks.filter((b: any) => b.block_type === "list_item").length;
  const hook = blocks.find((b: any) => b.block_type === "hook");
  const cta = blocks.find((b: any) => b.block_type === "cta");

  const typeLabels: Record<string, string> = {
    hook: "Hook",
    list_item: `${listItemCount} tip${listItemCount > 1 ? "s" : ""}`,
    conclusion: "Conclusion",
    cta: "CTA",
  };
  const seenTypes = new Set(blocks.map((b: any) => b.block_type));
  const metaParts = ["list_item", "hook", "conclusion", "cta"]
    .filter((t) => seenTypes.has(t))
    .map((t) => typeLabels[t]);

  return (
    <div className="listicle-preview-compact">
      {hook && <div className="hook">{hook.narration || hook.caption}</div>}
      <div className="listicle-preview-meta">
        {metaParts.join(" • ")}
      </div>
      {cta && <div className="preview">{cta.narration || cta.caption}</div>}
    </div>
  );
};

export default ListicleCard;
